module.exports = __webpack_public_path__ + "media/images/msf-ef852f919daf515dd6a65a44d699fad5.png";